<template>
  <div :class="getClass" class="table-search">
    <TableHeader
      :additional="headerAddition"
      :additional2="headerAddition2"
      :hide-price="hidePrice"
      :change-patient-client="changePatientClient"
    />
    <TableContainer
      v-for="order in orders"
      :key="order.id"
      :order="order"
      :tab="tab"
      :row-additional="rowAdditional"
      :row-additional2="rowAdditional2"
      :hide-price="hidePrice"
      :hide-ready-date="hideReadyDate"
      :open="open"
      :change-patient-client="changePatientClient"
      @open="id => open = (open === id ? null : id)"
    />
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import TableContainer from '@/containers/orders/TableContainer';
  import TableHeader from '@/containers/orders/TableHeader';

  export default {
    name: 'OrdersTable',
    components: {TableHeader, TableContainer},
    props: {
      tab: String,
      orders: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        open: null,
      };
    },
    computed: {
      ...mapState({
        role: state => state.auth?.user?.role || '',
      }),
      getClass () {
        // Give different grid layouts for different types of tables
        if (this.tab === 'in_progress' && this.role === 'lab_admin') return 'table-search-clinic-work';
        if (this.tab === 'in_progress' && this.role === 'lab_employee') return 'table-search-employee-progress';
        if (this.tab === 'completed' && this.role === 'lab_employee') return 'table-search-employee-completed';
        if (this.tab === 'completed' && this.role === 'client') return 'table-search-client-completed';
        if (this.tab === 'completed') return 'table-search-done';
        if (this.tab === 'rejected') return 'canceled';
        return '';
      },

      // Visual elements of orders like price or date of ready order
      hidePrice () {
        return this.role === 'lab_employee';
      },
      changePatientClient () {
        return this.role !== 'client';
      },
      hideReadyDate () {
        return this.tab === 'new';
      },

      // Control the 6th and 7th cells' behavior by giving it specific names
      headerAddition () {
        if (this.tab === 'active') return 'Статус';
        else if (this.tab === 'in_progress' && this.role === 'lab_admin') return 'Исполнитель';
        else if (this.tab === 'rejected') return 'Причина';
        return '';
      },
      headerAddition2 () {
        return (this.tab === 'new' ||
          this.tab === 'in_progress' ||
          (this.tab === 'completed' && this.role === 'client'));
      },

      // Control actions that can be performed from the order row for 6th and 7th columns
      rowAdditional () {
        if (this.tab === 'active') return 'status';
        else if (this.tab === 'rejected') return 'reason';
        else if (this.tab === 'new') return 'to_work';
        else if (this.tab === 'in_progress' && this.role === 'lab_admin') return 'employee';
        return '';
      },
      rowAdditional2 () {
        if (this.tab === 'in_progress' && this.role === 'lab_admin') return 'end-or-reject';
        else if (this.tab === 'in_progress' && this.role === 'lab_employee') return 'end';
        else if (this.tab === 'completed' && this.role === 'client') return 'to_milling';
        return '';
      },
    },
  };
</script>

<style lang="scss">
  .table-search.table-search-employee-progress {
    grid-template-columns: max-content 1fr 1fr 1.5fr 1fr 40px;
    .results-table-droplist {
      grid-area: auto/1/ auto / span 6 !important;
    }
  }
  .table-search.table-search-employee-completed {
    grid-template-columns: max-content 1fr 1fr 1.5fr 40px;
    .results-table-droplist {
      grid-area: auto/1/ auto / span 5 !important;
    }
  }
  .table-search.table-search-client-completed {
    grid-template-columns: max-content 1fr 1fr 1.5fr 1fr 1fr 40px;
    .results-table-droplist {
      grid-area: auto/1/ auto / span 7 !important;
    }
  }
</style>
